import { Button } from '@/components/catalyst-ui/button'
import { cn } from '@/lib/utils'
import { EmptyStateIcon, MagnifyingGlassIcon } from '@/assets/icons'

export function EmptyState({
  title,
  description,
  showButton = false,
  buttonLabel,
  buttonIcon: ButtonIcon,
  buttonDisabled = false,
  onButtonClick,
  className = '',
  icon = 'default',
  children,
}) {
  const shouldShowButton = showButton && buttonLabel && typeof onButtonClick === 'function'

  let IconComponent = EmptyStateIcon
  if (icon === 'search') {
    IconComponent = MagnifyingGlassIcon
  } else if (typeof icon === 'function') {
    IconComponent = icon
  }

  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center text-center min-h-[calc(100vh-245px)] px-4',
        'text-[#A1A1AA] bg-[#FAFAFA] border border-[#E4E4E7] rounded-sm',
        className
      )}
    >
      <div className="mb-2 flex items-center justify-center">
        <IconComponent className="w-24 h-24 text-[#D4D4D8]" />
      </div>

      <h2 className="text-lg font-semibold text-[#A1A1AA]">{title}</h2>
      {description && (
        <p className="mt-1 text-sm font-medium text-[#A1A1AA] max-w-sm">
          {description}
        </p>
      )}

      {children}

      {shouldShowButton && (
        <div className="mt-6">
          <Button
            color="dark"
            className="px-6 data-focus:!ring-2 data-focus:!ring-indigo-500 data-focus:!ring-offset-2"
            disabled={buttonDisabled}
            onClick={onButtonClick}
          >
            {ButtonIcon && <ButtonIcon className="h-4 w-4" />}
            {buttonLabel}
          </Button>
        </div>
      )}
    </div>
  )
}
